/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Git Fork",
  size: 20
}

const SvgGitFork = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.2} cx={5.79} cy={2.79} r={1.79} />
    <circle fill="none" strokeWidth={1.2} cx={14.19} cy={2.79} r={1.79} />
    <circle fill="none" strokeWidth={1.2} cx={10.03} cy={16.79} r={1.79} />
    <path
      fill="none"
      strokeWidth={2}
      d="M5.79 4.57v1.99c0 2.63 4.24 3.66 4.24 6.75 0 1.55.01 1.24.01 1.24v-1.24c0-3.09 4.16-4.12 4.16-6.75V4.57"
    />
  </Svg>
)

SvgGitFork.defaultProps = defaultProps
export default SvgGitFork
